import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Bills from "@/pages/Bills";
import PartialPayments from "@/pages/PartialPayments";
import BillForm from "@/pages/BillForm";
import BillPrint from "@/pages/BillPrint";
import Buyers from "@/pages/Buyers";
import Employees from "@/pages/Employees";
import RecycleBin from "@/pages/RecycleBin";
import Reconciliation from "@/pages/Reconciliation";
import AuditLog from "@/pages/AuditLog";
import Assistant from "@/pages/Assistant";
import Layout from "@/components/Layout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="flex h-screen items-center justify-center text-neutral-500">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/bills/:id/print"
            element={
              <Protected>
                <BillPrint />
              </Protected>
            }
          />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="bills" element={<Bills />} />
            <Route path="partial-payments" element={<PartialPayments />} />
            <Route path="bills/new" element={<BillForm />} />
            <Route path="bills/:id/edit" element={<BillForm />} />
            <Route path="buyers" element={<Buyers />} />
            <Route path="employees" element={<Employees />} />
            <Route path="recycle-bin" element={<RecycleBin />} />
            <Route path="reconciliation" element={<Reconciliation />} />
            <Route path="audit-log" element={<AuditLog />} />
            <Route path="assistant" element={<Assistant />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
